import {
  DEFAULTS_SETTINGS,
  getSettings,
  Settings,
} from "@/server/SettingsService";
import { storageService } from "@/services/StorageService";
import { useState } from "react";

export default function SettingsPage() {
  const [settings, setSettings] = useState<Settings>(getSettings());

  function handleSave() {
    console.info("Saving settings", settings);
    localStorage.setItem("settings", JSON.stringify(settings));
  }

  function handleResetBrowserDatabase() {
    storageService.resetDatabase();
  }

  return (
    <div>
      <div className="mb-4">
        <label className="block mb-8" htmlFor="openaikey">
          OpenAI API Key
        </label>
        <input
          type="text"
          placeholder="OpenAI API Key"
          id="openaikey"
          value={settings.openaiApiKey}
          onChange={(e) =>
            setSettings({ ...settings, openaiApiKey: e.target.value })
          }
          className="bg-slate-600 text-white text-xl w-full sm:w-[800px]"
        />

        <label className="block mt-8" htmlFor="openaimodel">
          Model
        </label>
        <select
          id="openaimodel"
          value={settings.model}
          onChange={(e) => setSettings({ ...settings, model: e.target.value })}
          className="border border-gray-300 p-2 bg-slate-600 text-white"
        >
          <option value="">Default</option>
          <option value="gpt-4o-2024-08-06">gpt-4o-2024-08-06</option>
        </select>

        <div>
          <label className="block mt-8" htmlFor="global-prompt">
            System Prompt to answer the survey in one go (directly aggregated
            answers).
            <br />A user prompt will be generated containing only a JSON object
            with the keys: questions, demographicTarget
          </label>
          <textarea
            id="global-prompt"
            placeholder=""
            value={settings.globalPrompt}
            onChange={(e) =>
              setSettings({ ...settings, globalPrompt: e.target.value })
            }
            rows={4}
            className="bg-slate-600 text-white mt-2 w-full h-[600px] min-h-[600px]"
          />
          <button
            className="btn-primary"
            onClick={() =>
              setSettings({
                ...settings,
                globalPrompt: DEFAULTS_SETTINGS.globalPrompt,
              })
            }
          >
            Reset prompt to default
          </button>
        </div>

        <div>
          <label className="block mt-8" htmlFor="insights-prompt">
            System Prompt to analyse the survey results.
            <br />A user prompt will be generated containing only a JSON object
            with the keys: survey, results. The survey object contains the whole
            data on the survey including the questions, goals, etc. The results
            are the aggregated respondents answers.
          </label>
          <textarea
            id="insights-prompt"
            value={settings.insightsPrompt}
            onChange={(e) =>
              setSettings({ ...settings, insightsPrompt: e.target.value })
            }
            rows={4}
            className="bg-slate-600 text-white mt-2 w-full h-[600px] min-h-[600px]"
          />
          <button
            className="btn-primary"
            onClick={() =>
              setSettings({
                ...settings,
                insightsPrompt: DEFAULTS_SETTINGS.insightsPrompt,
              })
            }
          >
            Reset prompt to default
          </button>
        </div>
      </div>

      <button className="btn-primary" onClick={handleSave}>
        Save
      </button>

      <hr className="mt-8 mb-8" />

      <button
        className="btn-primary dark:bg-red-500  dark:hover:bg-red-400"
        onClick={handleResetBrowserDatabase}
      >
        Reset Browser Database
      </button>
    </div>
  );
}
